import React, { memo } from "react";
import styled from "styled-components";
import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import icon_info_dialog from "assets/icon_info_dialog.svg";

const TimeoutCallStaffModal = memo(({ className, onClose, isShow }) => {
  const { t } = useTranslation("translation");
  return (
    <div className={className}>
      <div className={"row content flex justify-center"}>
        <div className="bg-tipping w-full">
          <div className="tipping-content flex justify-center items-center">
            <img
              src={icon_info_dialog}
              className="img-tipping-logo"
              alt="info"
            />
          </div>
          <div className="tipping-title font-700 fs-18 flex justify-center items-center">
            {t("notifyContentTimeoutCallStaff")}&nbsp;
          </div>
          <div className="tipping-title font-500 fs-14 flex justify-center items-center">
            {t("notifyContentTimeoutCallStaff1")}&nbsp;
          </div>
          <div
            className={"btnleft font-medium flex justify-center items-center"}
            onClick={onClose}
          >
            {t("close")}
          </div>
        </div>
      </div>
    </div>
  );
});

export default styled(TimeoutCallStaffModal)`
  position: relative;
    .btnCloseModal {
    margin-top: 10px;
  }
  .ant-layout-content {
    overflow-y: auto;
  }
  .tipping-title {
    text-align: center;
    margin-top: 10px;
  }
  .bg-tipping {
    margin-right: 20px;
    margin-left: 20px;
    margin-top: 20px;
  }
  .text-input {
    height: 44px;
    padding: 10px;
    display: flex;
    justify-content: start;
  }
  .btn_primary {
    width: "50%";
  }
  .tipping-input {
    background: #ffffff;
    border-radius: 4px;
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .tipping-line {
    margin-bottom: 10px;
  }
  .buttonModal {
    position: fixed;
    bottom: 0;
    display: flex;
    left: 0;
    right: 0;
    margin-bottom: 15px;
    margin-left: 20px;
    margin-right: 20px;
    align-items: center;
    justify-content: center;
  }
  .textarea {
    border: none;
    overflow: auto;
    outline: none;
    background: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;

    resize: none; /*remove the resize handle on the bottom right*/
  }
  .buttonModal {
    position: fixed;
    bottom: 0;
    display: flex;
    left: 0;
    right: 0;
    margin-bottom: 15px;
    margin-left: 20px;
    margin-right: 20px;
    align-items: center;
    justify-content: center;
  }
  .btnleft {
    color: #ffffff;
    background: #000000;
    border-radius: 4px;
    margin-top: 10px;
    margin-bottom: 15px;
    margin-left: 40px;
    margin-right: 40px;
    height: 44px;
  }
`;
